module.exports = __webpack_public_path__ + "77ebd5cb209312df8011fd00f117da2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/title-box.png
// module id = 558
// module chunks = 0